var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOptionPopup)?_c('div',{staticClass:"optionPopup"},[_c('div',{staticClass:"optionPopupText"},[_vm._v(" "+_vm._s(_vm.text ? _vm.text : _vm.$t('topUp.Tips'))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }